import { getAuth, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import EnvironmentSettings from "./Models/EnvironmentSettings";
import { HubConnectionBuilder } from "@microsoft/signalr";
import toast, { Toaster } from "react-hot-toast";

import Swal from "sweetalert2";
import firebaseConfig from "FirebaseConfig";
import UsersApi from "./API/UsersApi";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth();

class ConnectionService {
  constructor(CurrentUser) {
    EnvironmentSettings.Environment === "dev"
      ? (this.baseUrl = EnvironmentSettings.LocalUrl)
      : (this.baseUrl = EnvironmentSettings.LiveUrl);

    this.CurrentUser = CurrentUser;

    //console.log("Connection Service Started with user: ", this.CurrentUser);
    this.Connection = null;
    this.handleAppointmentDayUpdate = null;
  }

  async StartConnection() {
    const newConnection = new HubConnectionBuilder()
      .withUrl(this.baseUrl + "hubs/connections", {
        accessTokenFactory: async () => await UsersApi.GetToken(),
        // headers: {
        //   Authorization: `Bearer ${await UsersApi.GetToken()}`,
        // },
      })
      .withAutomaticReconnect()
      .build();

    this.Connection = newConnection;

    if (this.Connection != null) {
      this.Connection.start()
        .then(() => {
          //console.log("Connection Started");
          this.Connection.on("ConfirmConnection", (message) => {
            console.log("ConfirmConnection: ", message);
          });

          this.Connection.on("ReceiveBroadcast", (user, message) => {
            //console.log("ReceiveBroadcast: ", message);
            Swal.fire({
              title: user + " says: ",
              text: message,
              icon: "info",
              confirmButtonText: "Ok",
            });
          });

          this.Connection.on("ReceiveNotification", (message) => {
            console.log("ReceiveNotifation: ", message);
            // Swal.fire({
            //     text: message,
            //     icon: 'info',
            //     position: "bottom-right",
            //     timer: 3500,
            //     backdrop: false,
            //     showConfirmButton: false,
            //     toast: true
            // });

            toast.success(message, {
              position: "bottom-right",
              duration: 3500,
              padding: "1rem",
            });
          });

          this.Connection.on("AutoUpdateAppointmentDay", (AppHourId) => {
            console.log("AutoUpdateAppointmentDay: ", AppHourId);
            if (this.handleAppointmentDayUpdate) {
              this.handleAppointmentDayUpdate(AppHourId);
            }
          });

          this.Connection.invoke("Connect", this.CurrentUser.id);
        })
        .catch((err) => console.log(err));
    }
  }

  async StopConnection() {
    if (this.Connection != null) {
      this.Connection.invoke("Disconnect", this.CurrentUser.id);
      this.Connection.stop();
      this.Connection = null;
    }
  }

  async SendBroadcast(message) {
    await this.Connection.invoke("Broadcast", this.CurrentUser.name, message);
  }
}
export default ConnectionService;
